import { create } from 'zustand'

/** The Crate's halves: the collectibles shelf, the finds drawer, and the trip books (B10). */
export type CrateView = 'shelf' | 'finds' | 'books'

/**
 * Which half of the Crate shows (WI-13e): Finds by default (the tab's badge is about new finds);
 * the Arcade's "My shelf" opens it on the Shelf. Kept for the session, like a remembered tab.
 */
export const useCrateView = create<{ view: CrateView }>(() => ({ view: 'finds' }))
